import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import PropTypes from 'prop-types';

const FooterMenuActions = ({ menuOptions, className = '' }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={className}>
            <IconButton
                aria-label="more"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                sx={{ color: 'white' }}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: { zIndex: 10002 },
                    },
                }}
                sx={{ zIndex: 10002 }}
            >
                {menuOptions.map(({ label, subtitle, onClick, icon }) => (
                    <MenuItem
                        key={label}
                        onClick={() => {
                            handleClose();
                            onClick && onClick();
                        }}
                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {icon && <span style={{ marginRight: 8, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{icon}</span>}
                            <span style={label === 'Report Issue' ? { color: 'red' } : {}}>{label}</span>
                        </div>
                        {subtitle && <span style={{ color: '#888', fontSize: 12, marginLeft: icon ? 32 : 0, marginTop: 2 }}>{subtitle}</span>}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

FooterMenuActions.propTypes = {
    menuOptions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            subtitle: PropTypes.string,
            onClick: PropTypes.func,
            icon: PropTypes.node,
        })
    ).isRequired,
    style: PropTypes.object,
};

export default FooterMenuActions;
